import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry, SentryErrorBoundary } from "./sentry";
import { initPostHog } from "./lib/posthog";

initSentry();
initPostHog();

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold font-heading text-foreground">
          Something went wrong
        </h1>
        <p className="text-muted-foreground">
          An unexpected error occurred. Refresh the page to try again — if the
          problem persists, the engineering team has been notified.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center justify-center px-6 py-2 bg-[#111827] text-white rounded-md font-medium hover:bg-[#1a2332] transition-colors"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <SentryErrorBoundary fallback={<ErrorFallback />}>
    <App />
  </SentryErrorBoundary>,
);
